var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "page vertical-align text-center",
        attrs: {
          "data-animsition-in": "fade-in",
          "data-animsition-out": "fade-out",
        },
      },
      [
        _c("div", { staticClass: "page-content vertical-align-middle" }, [
          _c("i", {
            staticClass: "icon wb-settings icon-spin page-maintenance-icon",
            attrs: { "aria-hidden": "true" },
          }),
          _c("h2", [_vm._v("กำลังออกจากระบบ...")]),
          _c("p", [_vm._v("กรุณารอสักครู่ ระบบกำลังทำงาน")]),
          _c("footer", { staticClass: "page-copyright" }, [
            _c("p", [_vm._v("PMI Thailand")]),
            _c("p", [_vm._v("© 2018. All RIGHT RESERVED.")]),
            _c("div", { staticClass: "social" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-icon btn-pure",
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _c("i", {
                    staticClass: "icon bd-twitter",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "btn btn-icon btn-pure",
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _c("i", {
                    staticClass: "icon bd-facebook",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
              _c(
                "a",
                {
                  staticClass: "btn btn-icon btn-pure",
                  attrs: { href: "javascript:void(0)" },
                },
                [
                  _c("i", {
                    staticClass: "icon bd-dribbble",
                    attrs: { "aria-hidden": "true" },
                  }),
                ]
              ),
            ]),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }